import { render, staticRenderFns } from "./calendarBody.vue?vue&type=template&id=98f75b5a&scoped=true"
import script from "./calendarBody.vue?vue&type=script&lang=js"
export * from "./calendarBody.vue?vue&type=script&lang=js"
import style0 from "./calendarBody.vue?vue&type=style&index=0&id=98f75b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f75b5a",
  null
  
)

export default component.exports